// extracted by mini-css-extract-plugin
export default {"thumbnailImageFrame":"PJqLumG9KIb60ENlJ6Mb","thumbnailImage":"lXdqB03N4PrwXVqN_h6V"};